export default "__VITE_ASSET__1T$NsciO__"